/* Sepette yasal onay kutuları.
   Kutuların tamamı işaretlenmeden formun gönderilmesini (ödemeye geçişi) engeller.
   Onaylandığında zaman damgasını gizli alana yazar; bu alan sepet özniteliği
   olarak checkout'a taşınır ve sipariş detayında kalıcı kayıt olur. */
if (!customElements.get("cart-consent")) {
  class CartConsent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === "1") return;
      this.dataset.ready = "1";

      this.boxes = Array.prototype.slice.call(
        this.querySelectorAll("[data-consent-box]"),
      );
      this.error = this.querySelector("[data-consent-error]");
      this.stamp = this.querySelector("[data-consent-stamp]");

      const formId = this.dataset.formId;
      const form = formId ? document.getElementById(formId) : null;
      if (!form || !this.boxes.length) return;

      const self = this;

      this.boxes.forEach(function (box) {
        box.addEventListener("change", function () {
          if (self.allChecked() && self.error) {
            self.error.classList.remove("is-visible");
          }
        });
      });

      form.addEventListener("submit", function (event) {
        if (!self.allChecked()) {
          event.preventDefault();
          event.stopPropagation();
          if (self.error) self.error.classList.add("is-visible");
          try {
            self.scrollIntoView({ block: "center", behavior: "smooth" });
          } catch (error) {
            /* eski tarayıcıları boş ver */
          }
          return;
        }

        if (self.stamp) {
          self.stamp.value =
            "On Bilgilendirme Formu, Mesafeli Satis Sozlesmesi ve KVKK Aydinlatma Metni onaylandi: " +
            new Date().toISOString();
        }
      });
    }

    allChecked() {
      return this.boxes.every(function (box) {
        return box.checked;
      });
    }
  }

  customElements.define("cart-consent", CartConsent);
}
